import $ from 'jquery';
import Prefixed from 'modules/prefixed/prefixed';

export default class {
	constructor(options) {
		const defaults = {
			el: '#headerNav',
			dom: {
				item: '.js-nav-item',
				subnav: '.js-subnav',
				subnavItem: '.js-subnav-item',
				subnavLine: '.js-subnav-line'
			},
			classes: {
				current: 'b-header-nav__item_state_current',
				hover: 'b-header-nav__item_state_hover',
				active: 'b-header-nav__item_state_active'
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.enterTimeout = false;
		this.leaveTimeout = false;
		this.$window = $(window);
		this.hash = false;
		this.prefixed = new Prefixed();
		return this;
	}

	getDom() {
		this.$item = this.$el.find(this.options.dom.item);
		this.$current = this.$item.filter('.' + this.options.classes.current);
		this.$subnav = this.$current.find(this.options.dom.subnav);
		this.$subnavItem = this.$subnav.find(this.options.dom.subnavItem);
		this.$subnavLine = this.$current.find(this.options.dom.subnavLine);
		return this;
	}

	onMouseenter(event) {
		const self = this;
		const $target = $(event.currentTarget);
		self.$item.not($target).removeClass(self.options.classes.hover);
		$target.addClass(self.options.classes.hover);
		clearTimeout(self.enterTimeout);
		clearTimeout(self.leaveTimeout);
		if (!$target.hasClass(self.options.classes.active)) {
			self.enterTimeout = setTimeout(function () {
				self.$item.not($target).removeClass(self.options.classes.active);
				$target.addClass(self.options.classes.active);
			}, 250);
		}
	}

	onMouseleave(event) {
		const self = this;
		const $target = $(event.currentTarget);
		$target.removeClass(self.options.classes.hover);
		clearTimeout(self.enterTimeout);
		clearTimeout(self.leaveTimeout);
		self.leaveTimeout = setTimeout(function () {
			self.$item.not(self.$current).removeClass(self.options.classes.active);
			self.$current.addClass(self.options.classes.active);
		}, 250);
	}


	setLine() {
		if (this.$subnavActive.length && this.$subnavLine.length) {
			const left = this.$subnavActive.offset().left - this.$subnavItem.eq(0).offset().left;
			const width = this.$subnavActive.outerWidth();
			const scale = 1 / 100 * width;
			this.$subnavLine.css(this.prefixed.css.transform, 'translateX(' + left + 'px) scaleX(' + scale + ') translateZ(0px)');
		}
	}


	onHash() {
		const hash = '#' + this.$window.data('hash');
		if (hash !== this.hash) {
			this.hash = hash;
			this.$subnavActive = this.$subnavItem.filter('[href*="' + this.hash + '"]');
			this.setLine();
		}
	}

	render() {
		if (this.$el.length) {
			this.getDom();

			this.$item
				.on('mouseenter', this.onMouseenter.bind(this))
				.on('mouseleave', this.onMouseleave.bind(this));

			if (this.$subnav.length && this.$subnavItem.length) {
				this.$subnavActive = this.$subnavItem.first();
				this.$window
					.on('resize.nav', this.setLine.bind(this))
					.on('yota.router.hash', this.onHash.bind(this));
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/partials/site/header/nav/nav.js